import React, { Component } from 'react';
import PropTypes from 'prop-types';
import copy from 'copy-to-clipboard';
import { connect } from 'react-redux';
import { makeShortLink } from '../../store/actions/shareButtons';
import { ToastContainer, toast } from 'react-toastify';
import Button from '../buttons/Button';
import ReactGA from 'react-ga';

function notify() {
  toast('Link został skopiowany do schowka.', {
    closeOnClick: true,
    position: 'top-right',
    autoClose: 10000,
    toastId: 1, // show only one
  });
}

class ShareGetShortUrlPopUpContent extends Component {
  componentDidMount() {
    this.props.getLink();
  }

  copyToClipboard = e => {
    ReactGA.event(
      {
        category: 'Shares',
        action: 'Create short link',
        transport: 'beacon',
      },
      ['tracker1', 'tracker2'],
    );
    copy(e, {
      format: 'text/plain',
    });
    notify();
  };

  render() {
    return (
      <div className="pop-up__content">
        <div className="pop-up__content-item">
          <p>Link do konfiguracji:</p>
          <input type="text" readOnly className="share_input" value={this.props.link} />
          <Button
            click={() => this.copyToClipboard(this.props.link)}
            text="Kopiuj Link"
            color="primary"
          />
        </div>
        <ToastContainer />
      </div>
    );
  }
}

ShareGetShortUrlPopUpContent.propTypes = {
  getLink: PropTypes.func.isRequired,
  link: PropTypes.string,
};

const mapStateToProps = state => {
  return {
    token: state.token.token,
    link: state.socialShare.hash || '',
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getLink: () => dispatch(makeShortLink(ownProps.token)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareGetShortUrlPopUpContent);
